const defaultLogger = console

export default defaultLogger
